/* global requirejs */
import { getConfiguration } from "./configuration";

export const initialise = context =>
  new Promise(resolve =>
    requirejs(["bagSdk/sdk"], sdk =>
      resolve(sdk.getInstance(context, getConfiguration()))
    )
  );



// WEBPACK FOOTER //
// ./client/sdk/bag.js